import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const wrapper = css`
    margin: 1rem;
    .row,
    .col {
      margin: 0;
    }
    .col {
      padding: 0;
    }
  `;

  const title = css`
    ${theme.typography.h1}
    color: ${theme.colors.navy["1"]};
  `;

  const line = css`
    background-color: ${theme.colors.gray["2"]};
    margin: 1rem 0.5r;
    width: 100%;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
    padding: 1.25em 1em;
  `;

  const cardHeader = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      ${theme.typography.h2}
      margin: unset;
      color: ${theme.colors.navy["1"]};
    }
  `;

  const cardTitle = css`
    display: flex;
    align-items: center;
  `;

  const cardIcon = css`
    width: 24px;
    height: 24px;
    margin-right: 0.5rem;
    color: ${theme.colors.teal["1"]};
  `;

  const emptyState = css`
    text-align: center;
    padding: 2rem 1rem;
    h3 {
      ${theme.typography.h3}
      color: ${theme.colors.navy["1"]};
    }
    p {
      ${theme.typography.p}
      color: ${theme.colors.navy["1"]};
    }
  `;

  const projectLink = css`
    color: ${theme.colors.teal["1"]};
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: ${theme.colors.teal["1"]};
      text-decoration: underline;
    }
  `;

  const numericCell = css`
    text-align: right;
  `;

  return {
    wrapper,
    title,
    line,
    card,
    cardHeader,
    cardTitle,
    cardIcon,
    emptyState,
    projectLink,
    numericCell,
  };
};

export default useStyles;
